import * as THREE from 'three';
import { globalStores } from '@/editor/stores';
import { pixelRatio2d } from '@/editor/math/const';
import { EEntityType } from '@/editor/types';
import BaseModel2d from './BaseModel2d';
import { setModelVisible } from '../utils';

export class FloorPlanPdfModel extends BaseModel2d {
  private _canvasTexture: THREE.CanvasTexture | null = null;
  constructor() {
    super();
    this._modelGroup.userData.type = EEntityType.FloorPlan;
    globalStores.editorStateStore.sceneInfo.scene2d.scene.add(this._modelGroup);
  }

  override setVisible(visible: boolean) {
    setModelVisible(this._modelGroup, visible);
  }

  async render(canvas: HTMLCanvasElement | null, factor: number) {
    this.clear();

    if (!canvas) return;

    const model = this.createModel(canvas, factor);

    if (!model) return;

    this._modelGroup.add(model);
  }

  override clear() {
    super.clear();
  }

  createModel(canvas: HTMLCanvasElement, factor: number) {
    const canvasRenderScale = canvas.dataset.pdfRenderScale ? parseFloat(canvas.dataset.pdfRenderScale) : 1;
    const sceneWidth = this._ptToSceneSize(canvas.width) / canvasRenderScale;
    const sceneHeight = this._ptToSceneSize(canvas.height) / canvasRenderScale;

    this._canvasTexture = new THREE.CanvasTexture(canvas);

    const mesh = new THREE.Mesh(
      new THREE.PlaneGeometry(sceneWidth * factor, sceneHeight * factor, 1, 1),
      new THREE.MeshBasicMaterial({
        map: new THREE.CanvasTexture(canvas)
      })
    );

    return mesh;
  }

  private _ptToSceneSize(pt: number) {
    const inches = pt / 72; // 1 inch = 72 points
    const millimeters = inches * 25.4; // 1 inch = 25.4 millimeters
    return millimeters / pixelRatio2d;
  }

  override dispose() {
    if (this._canvasTexture) {
      this._canvasTexture.dispose();
      this._canvasTexture = null;
    }
    super.dispose();
  }
}
